import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { StageResponse } from "~types/stage.ts";
import { removeEmptyFields } from "~utils/removeEmptyFields.ts";
import { transformListResponse } from "~utils/transformListResponse.ts";

type Props = {
  customParams: Record<string, string>;
  enabled?: boolean;
};

export const useFetchSeasonStages = ({ customParams, enabled = true }: Props) => {
  const request = useApi();
  const { organizationId, sport, seasonId } = useParams();

  const params = new URLSearchParams(removeEmptyFields(customParams) as Record<string, string>);

  return useQuery({
    queryKey: ["seasonStages", sport, organizationId, seasonId, customParams],
    enabled,
    queryFn: () =>
      request<StageResponse>(`${sport}/o/${organizationId}/seasons/${seasonId}/stages?${params.toString()}`).then((response) => {
        return transformListResponse(response);
      }),
  });
};
